import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../store/store';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import { checkPaymentAsync } from '../../store/slices/payment/paymentThunk';
import GeneralPageLayout from '../../components/layout/GeneralPageLayout';
import { useCloseWindow } from '../../hooks/useCloseWindow';
import {
  selectConfigSettings,
  selectConfigExpressSettingsName,
} from '../../store/slices/config/configSelectors';
import { selectPaymentSuccessInfo } from '../../store/slices/payment/paymentSelectors';
import { PAYMENT_PROVIDER } from '../../types/payment';

const PaymentSuccess = () => {
  const dispatch = useAppDispatch();
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
  const placeDisplayName = useSelector(selectConfigExpressSettingsName);
  const settings = useSelector(selectConfigSettings);
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  const { express, rentalType, payment_provider: paymentProvider } = settings;

  const currentFlow = useSelector(selectCurrentFlow);

  const { isAbleToCloseWindow, closeWindow } = useCloseWindow();

  useEffect(() => {
    const paymentId = params.get('paymentId');

    if (paymentId) {
      dispatch(checkPaymentAsync(paymentId, currentFlow, () => {}));
    }
  }, [paymentProvider, params, currentFlow]);

  return (
    <GeneralPageLayout
      flow={currentFlow}
      next="Close Window"
      showNext={isAbleToCloseWindow}
      onNext={closeWindow}
    >
      <p>
        <span>
          Thank you! Your {express?.registration?.verbiage} Application has been
          submitted successfully!
        </span>
        <span>
          {paymentSuccessInfo?.paymentConfirmation
            ? ` Your confirmation number is: ${paymentSuccessInfo?.paymentConfirmation}.`
            : ''}
        </span>
        <span>
          We have emailed you details of the application. Your application will
          be reviewed and processed by {placeDisplayName}{' '}
          {rentalType?.toUpperCase()}.
        </span>
        <span>
          We will contact you via email on the status of your application.
        </span>
      </p>
    </GeneralPageLayout>
  );
};

export default PaymentSuccess;
